import React from 'react'
import './style.css'
import { map } from 'lodash'
import { upgradeSubscription } from '~/redux/user/helpers'
import PopupPlan from '~/components/PopupPlan'
import popup from '../../popup'
import connect from "~/tools/connect";
import userStore from "~/redux/user/store"

class UpgradeSubscription extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: null,
      processing: false
    }
  }

  render() {
    return(
      <div className={`upgrade-subscription centered opaque padded ${this.state.processing ? 'processing' : ''}`}>
        <h1>Upgrade Subscription Plan</h1>
        <p>Select a plan below to upgrade your experience.</p>
        <div className="upgrade-plans-container">
          { this.renderPlans() }
        </div>
        { this.state.alert && <div className="alert"> { this.state.alert } </div> }
        <div className="legal-texts">
           <p>Upon cancellation, service access and use will end upon the completion of paid monthly or annual terms.<br/>Service access will end immediately upon cancellation if during a free trial period.</p>
           <p>There is no refund for early termination of annual plan.</p>
         </div>
      </div>
    )
  }

  renderPlans() {
    const plans = this.state.user.subscription.plans

    if (plans.length > 0) {
      return map(plans, data => {
        return (
          <PopupPlan
            plan={ data }
            key={ data.id }
            selected={ this.state.selected === data.id }
            buttonText={ 'Upgrade Plan' }
            hideFreeTrialText={ true }
            onClick={ () => this.changePlan(data) }/>
        )
      })
    } else {
      return <div>No plans available</div>
    }
  }

  changePlan(plan) {
    if (plan.id !== this.state.selected)
      return this.setState({ selected: plan.id })

    var paymentHandler = this.state.user.subscription.subscriptionInfo.paymentHandler.toLowerCase()
    this.setState({ processing: true })
    upgradeSubscription(plan, paymentHandler)
      .then( popup.hide )
      .catch(e => {
        var error = ((e.response || {}).data || {}).error
        this.alert(error || 'We were unable to update your subscription.')
      })
      .then(_ => { this.setState({ processing: false }) })
  }

  alert(msg) {
    this.setState({ alert: msg })
    setTimeout(_ => this.setState({ alert: null }), 4000)
  }
}

connect(UpgradeSubscription, (state) => ({ user: state.user }), userStore)

export default UpgradeSubscription;
